import { render, staticRenderFns } from "./Hello.vue?vue&type=template&id=7930943a&"
import script from "./Hello.vue?vue&type=script&lang=ts&"
export * from "./Hello.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports